import axios from 'axios'
import basicUrl from './basicUrl'
import router from '@/router'
import { message } from 'ant-design-vue';
import getMd5Form from '@/utils/getMd5Form.js'
// import { useStore } from 'vuex'
// let store = useStore()
import store from '../store';
import { rpcAuth } from '@/api/rpcauth.js'

export const instance = axios.create({
  baseURL: basicUrl,
  timeout: 600000
});

// 设置放行路由，放行错误控制
var role = []
// 不显示loading的接口(答题卡上传，进度条接口)
var noLoadingApi = [
  '/api/v1/user/record_use_time',
]
 
function addInterceptors (face) {
  face.interceptors.request.use(config => {
    if (!config.noloading&&noLoadingApi.indexOf(config.url) == -1) {
      store.commit('loading/add')
    }
      if (config.url == '/api/v1/user/new_study_report') {
          if (window.location.href.includes("xlccz")) {
            config.params.is_xlc = 1
          } else {
            config.params.is_xlc = 0
          }
        }
    if(config.url == '/api/v1/user/new_study_report'&&config.params.show_question==1){
  store.commit('loading/setTip', '正在生成中，由于学案数据较大，需1-2分钟，请耐心等待...')
    }else if(config.url == '/api/v1/user/new_study_report'&&config.params.show_question==0){
      store.commit('loading/setTip', '正在生成中，请耐心等待...')
    }
    else{
      store.commit('loading/setTip', '加载中...')
    }
    if (config.url != '/api/v1/auth/refresh_token' || config.url != '/api/v2/login') {
      // await getTime()
    }

    if (config.url == '/api/v1/login') {
      rpcAuth().then(res => {
        window.localStorage.setItem('appToken', JSON.stringify(res.data));
      }).catch(err => {
        console.log(err);
      })
    }

    if ( config.url.includes("skb::") ) {
      config.url = config.url.replace("skb::", "")
      config.baseURL =  process.env.NODE_ENV === 'development' ? "http://10.10.11.250:705" : 'https://slbk.sunrayai.cn'
    }

    if (window.localStorage.getItem('userInfo')) {
      let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
      config.headers['Authorization'] = `Bearer ${userInfo.token}`
    }

    if (!config.headers.isRefresh) {
      delete config.headers.isRefresh
      if (config.method == 'get') {
        if (!config.params) {
          config.params = {}
        }
        config.params.sign = getMd5Form(config.params, config.url)
      }
      else {
        if (!config.data) {
          config.data = {}
        }
        config.data.sign = getMd5Form(config.data, config.url)
      }
      delete config.headers.isRefresh
    }
    return config
  })
  face.interceptors.response.use(async config => {
       if (noLoadingApi.indexOf(config.config.url) == -1) {
        store.commit('loading/sub')
    }
 
    if (role.findIndex(item => item == config.config.url) != -1) {
      return config
    }
    config = config.data
    if (config.status === undefined && config.msg === undefined) {
      return config
    }
    return await new Promise((resolve, reject) => {
  if (
  config.status == 200 ||
  (config.data && (
    config.data.code == 40022003 ||
    config.data.code == 400220002 ||
    config.data.code == 40022001
  ))
) {
        resolve(config)
      } else {
        // 当状态码不为200的时候，直接拦截
        if (config.msg == 'error') {
          message.error(config.data.msg)
        } else {
          if ((config.status == 410000 || config.status == 410005) && JSON.parse(window.localStorage.getItem('userInfo'))) {
            //未登录状态下的提示语
            message.error(config.msg)
          } else if (config.status != 410000 && config.status != 410005) {
            //登录状态下的提示语

            message.error(config.msg)
          }
        }
        // console.log(config.status)
        if ((config.status == 410000||config.status == 410005)) {
          window.sessionStorage.clear()
       window.localStorage.clear()
          // window.localStorage.setItem('unLogingMeassgeM', true)//设置标记 避免重复提示
          router.push('/login?not_auto_login=1')

        }
        reject(config)
      }
    })
  }, error => {
    if (error.message.includes("timeout")) {
      message.error("请求超时，请稍后重试")
      if (store.state.loading.spinning > 0) {
        store.commit('loading/sub')
      }
    }
    console.log(error, "error")
  })
}

addInterceptors(instance)
